import { render, staticRenderFns } from "./JobAlertDeactivation.vue?vue&type=template&id=5ad94dc5&"
import script from "./JobAlertDeactivation.vue?vue&type=script&lang=ts&"
export * from "./JobAlertDeactivation.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports